import { useAlert } from "react-alert";
import { getAuth, signOut } from "firebase/auth";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import { fr, enGB, nl } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import { Blocks } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import userAction from "../../../../redux/users/action";
import dropIco from "../../../../images/dropIco.svg";
import userPic from "../../../../images/user.png";
import "../global.css";
import openSidebar from "../../../../images/openSidebar.png";

function Navbar({
  setDateRange,
  startDate,
  endDate,
  setDateClickHandle,
  dateClickHandle,
  setDateResetHandle,
  dateResetHandle,
  setPaymentMethod,
  paymentMethod = "",
  comparisonEnabled = false,
  setComparisonEnabled,
  sidebarOpen,
  toggleSidebar,
  organizations = [],
  orgId = [],
  setOrgId,
  onCreateNewPos,
  isCreatingNewPos = false,
}) {
  const { t, i18n } = useTranslation("navbar");
  const { t: tDashboard } = useTranslation("dashboard");
  const { t: tOrganization } = useTranslation("organization");
  const { next } = useParams();
  const dispatch = useDispatch();
  const { setUser } = userAction;
  const userStore = useSelector((state) => state.userReducer);

  const alert = useAlert();

  const [loader, setLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOrgDropdownOpen, setIsOrgDropdownOpen] = useState(false);
  const orgDropdownRef = useRef(null);
  const showOrgSelector = next !== "overview" && organizations.length > 0 && typeof setOrgId === "function";
  const showNewPosButton = next === "organizations" && typeof onCreateNewPos === "function";
  const selectedOrg = organizations.find((org) => org.id === orgId?.[0]);
  const selectedOrgLabel = isCreatingNewPos
    ? tOrganization("newPos")
    : selectedOrg?.organization || organizations[0]?.organization;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (orgDropdownRef.current && !orgDropdownRef.current.contains(event.target)) {
        setIsOrgDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logout = async () => {
    try {
      setLoader(true);
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          dispatch(setUser());
          alert.show(t("logout_success"));
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
          alert.show(t("logout_error"));
          setLoader(false);
        });
    } catch (e) {
      alert.show(t("logout_error"));
      setLoader(false);
    }
  };

  return (
    <>
      <nav className={`navbar-expand navbar-light topbar${next === 'overview' ? ' pos-overview-header' : ''}`}>
        {next === "overview" && (
          <div className="inputRefreshDivContainer pos-overview-toolbar">
            {!sidebarOpen && window.innerWidth > 576 && (
              <button className="sidebarToggleButton" onClick={toggleSidebar}>
                <img src={openSidebar} alt="Open sidebar" />
              </button>
            )}
            <div className="inputDivContainer">
              {!comparisonEnabled && <div className="inputDiv">
                <label className="visually-hidden" htmlFor="pos-overview-period">{tDashboard("comparison_p1")}</label>
                <DatePicker id="pos-overview-period" dateFormat="dd/MM/yyyy"
                  locale={{ fr, en: enGB, nl }[i18n.language.split("-")[0]] || enGB}
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                />
                <div className="submitDateMain">
                  <button type="button" title={t("submit")} aria-label={t("submit")}
                    className="fas fa-paper-plane" disabled={!startDate || !endDate || startDate > endDate}
                    onClick={() => setDateClickHandle(!dateClickHandle)} />
                </div>
              </div>}
              <div className="inputDiv">
                <select className="form-control" value={paymentMethod} aria-label={t("payment_method")} onChange={(e) => setPaymentMethod(e.target.value)}>
                  <option value="">
                    {t("payment_method")}
                  </option>
                  <option value="all">{t("all")}</option>
                  <option value="card">{t("card")}</option>
                  <option value="cash">{t("cash")}</option>
                  <option value="qr">QR</option>
                  <option value="bankTransfer">{t("bankTransfer")}</option>
                  <option value="cashless">{t("Cashless")}</option>
                </select>
                <img className="dropIco" src={dropIco} alt="" />
              </div>
            </div>
            <button type="button" className="pos-comparison-toggle"
              aria-pressed={comparisonEnabled} onClick={() => setComparisonEnabled(!comparisonEnabled)}>
              {tDashboard(comparisonEnabled ? "comparison_close" : "comparison_title")}
            </button>
            <button type="button" aria-label={t("reset_filter")}
              title={t("reset_filter")} className="fas fa-sync-alt resetIcon ms-2"
              onClick={() => setDateResetHandle(!dateResetHandle)} />
          </div>
        )}
        <div
          className="topbarSidebarProfileContainer"
          style={{
            justifyContent:
              !sidebarOpen && (window.innerWidth <= 576 || next !== "overview")
                ? "space-between"
                : "flex-end",
          }}
        >
          {!sidebarOpen && (window.innerWidth <= 576 || next !== "overview") && (
            <button className="sidebarToggleButton" onClick={toggleSidebar}>
              <img className="img-fluid" src={openSidebar} alt="Open sidebar" />
            </button>
          )}
          {(showOrgSelector || showNewPosButton) && (
            <div className="topbar-org-actions">
              {showOrgSelector && (
                <div className="topbar-org-select" ref={orgDropdownRef}>
                  <label id="dashboardOrgSelectLabel">{t("organization")}</label>
                  <div className="topbar-org-select-control">
                    <button
                      type="button"
                      className={`topbar-org-select-trigger ${isOrgDropdownOpen ? "is-open" : ""}`}
                      onClick={() => setIsOrgDropdownOpen((value) => !value)}
                      aria-haspopup="listbox"
                      aria-expanded={isOrgDropdownOpen}
                      aria-labelledby="dashboardOrgSelectLabel"
                    >
                      <span>{selectedOrgLabel}</span>
                    </button>
                    <img className="dropIco" src={dropIco} alt="" />
                    {isOrgDropdownOpen && (
                      <div className="topbar-org-select-menu" role="listbox">
                        {organizations.map((org) => (
                          <button
                            key={org.id}
                            type="button"
                            className={`topbar-org-select-option ${
                              org.id === selectedOrg?.id ? "is-selected" : ""
                            }`}
                            onClick={() => {
                              setOrgId([org.id]);
                              setIsOrgDropdownOpen(false);
                            }}
                            role="option"
                            aria-selected={org.id === selectedOrg?.id}
                          >
                            <span>{org.organization}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {showNewPosButton && (
                <button
                  type="button"
                  className="topbar-new-pos-button"
                  onClick={() => {
                    setIsOrgDropdownOpen(false);
                    onCreateNewPos();
                  }}
                >
                  <span className="topbar-new-pos-button-icon">+</span>
                  {tOrganization("newPos")}
                </button>
              )}
            </div>
          )}
          <div className="navbar-nav dropdown no-arrow nav-item">
            <div
              className="nav-link profileLink dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={() => setIsOpen(!isOpen)}
            >
              <div className="profile-div me-2">
                <p className="mr-2 profile-name">
                  {userStore?.users?.username || userStore?.users?.email.split("@")[0]}
                </p>
                <p className="status">{userStore?.users?.email}</p>
              </div>
              <div className="img-profile rounded-circle">
                <img
                  className="img-fluid"
                  src={userStore?.users?.profilePic ? userStore?.users?.profilePic : userPic}
                />
              </div>
            </div>

            {isOpen && (
              <div
                className="dropdown-menu show"
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  zIndex: 1000,
                }}
              >
                <a className="dropdown-item" href="#" onClick={logout}>
                  <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                  {t("logout")}
                </a>
              </div>
            )}
            {/* <div
              className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="userDropdown"
            >
              <a className="dropdown-item" href="#" onClick={logout}>
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                {t("logout")}
              </a>
            </div> */}
          </div>
        </div>
      </nav>
      {loader && (
        <div className="blockLoader">
          <Blocks
            visible={loader}
            height="80"
            width="80"
            ariaLabel="blocks-loading"
            wrapperStyle={{}}
            wrapperClass="blocks-wrapper"
          />
        </div>
      )}
    </>
  );
}

export default Navbar;
